import React from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import HttpClient from "services/HttpClient";
import fetch from "isomorphic-fetch";

import MyRegularWS_List from "./MyRegularWS_List";
import MyRegularWS_Panel from "./MyRegularWS_Panel";

@withRouter
@inject("myRegularWorkshops", "modal", "alert")
@observer
export default class MyRegularWorkshopsAttendees extends React.Component {
  state = {
    workshop: {},
    selected: []
  };

  componentDidMount() {
    this.getWorkshop();
  }

  getWorkshop = () => {
    const url = `/api/v1/workshops/${this.props.match.params.id}`;
    new HttpClient().get(url).then(response => {
      const workshop = response.body.data.workshop;
      this.setState({
        workshop: workshop,
        selected: []
      });
    });
  };

  showModal = e => {
    e.stopPropagation();
    this.props.modal.modalContentSetter("create_atendee");
    this.props.modal.toggleModal();
    this.props.modal.setSubmitFunction(this.onSubmit);
  };

  showEmailTemplate = () => {
    this.props.modal.modalContentSetter("email_template");
    this.props.modal.parentIdSetter(this.props.match.params.id);
    this.props.modal.toggleModal();
  };

  showCertTemplate = () => {
    const url = `/api/v1/attendees_list/pdf_template?workshop_id=${
      this.state.workshop.id
    }`;
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Token token=${localStorage.token}`);
    let init = {
      method: "GET",
      headers: headers,
      cache: "no-cache"
    };
    fetch(url, init)
      .then(resp => {
        if(resp.status=='200'){
        resp.blob()
        .then( file => {
        let objUrl = window.URL.createObjectURL(file)
          window.open(objUrl)
      })
      }
      else {
        alert("Something went wrong. Please check your connection or try again later")
      }
    })
  }

  selectedCheckbox = attendee_id => {
    let selectedValues;
    if (this.state.selected.indexOf(attendee_id) == -1) {
      selectedValues = [...this.state.selected, attendee_id];
    } else {
      selectedValues = [...this.state.selected].filter(
        item => item != attendee_id
      );
    }
    this.setState({
      ...this.state,
      selected: selectedValues
    });
  };

  selectAll = () => {
    let newSelected = [];
    const attendees = this.state.workshop.attendees;
    if (!this.state.selected.length) {
      attendees.map(attendee => newSelected.push(attendee.id));
    }
    this.setState({
      ...this.state,
      selected: newSelected
    });
  };

  onEdit = attendee => {
    this.props.modal.modalContentSetter("create_atendee");
    this.props.modal.setAssignedTo(attendee);
    this.props.modal.toggleModal();
    this.props.modal.setSubmitFunction(this.onUpdate);
  };

  onUpdate = attendee => {
    const url = `/api/v1/attendees_list/${attendee.id}`;

    new HttpClient()
      .put(url, attendee)
      .then(response => {
        const attendeeIndex = this.state.workshop.attendees.findIndex(
          item => item.id == attendee.id
        );
        console.log("attendeeIndex=", attendeeIndex);
        this.setState({
          ...this.state,
          workshop: {
            ...this.state.workshop,
            attendees: this.state.workshop.attendees.map(att =>
              att.id === attendee.id ? attendee : att
            )
          }
        });
        this.props.modal.toggleModal();
        this.props.alert.success("Attendee Updated!");
      })
      .catch(res => {
        this.props.alert.error(res.body.message.join(", "));
      });
  };

  onSubmit = object => {
    const params = {
      workshop_id: this.state.workshop.id,
      attendees: [object]
    };
    const url = "/api/v1/attendees_list";

    new HttpClient()
      .post(url, params)
      .then(response => {
        const attendees = response.body.attendees;
        this.setState({
          ...this.state,
          workshop: {
            ...this.state.workshop,
            attendees: attendees
          }
        });
        this.props.modal.toggleModal();
        this.props.alert.success("Attendee Added");
      })
      .catch(res => {
        this.props.alert.error(res.body.message.join(", "));
      });
  };

  onDelete = id => {
    const url = `/api/v1/attendees_list/${id}`;

    new HttpClient().delete(url).then(response => {
      const attendees = this.state.workshop.attendees.filter(
        item => item.id !== id
      );
      this.setState({
        ...this.state,
        workshop: {
          ...this.state.workshop,
          attendees: attendees
        }
      });
      this.props.alert.success("Attendee Deleted!");
    });
  };
  sendSertificate = () => {
    const url = "/api/v1/attendees_list/send_certificates";
    const params = {
      attendees_ids: this.state.selected,
      workshop_id: this.state.workshop.id
    };

    if (this.state.selected.length == 0) {
      this.props.alert.error("No attendees specified to send CPD Certs to");
      return;
    }

    new HttpClient()
      .post(url, params)
      .then(response => {
        this.getWorkshop();
        this.props.alert.success("CPD Certs Successfully Sent to Attendees");
      })
      .catch(res => {
        this.props.alert.error(res.body.message);
      });
  };

  loadAttachment = (e, field) => {
    const file = e.currentTarget.files[0];
    const url = `/api/v1/workshops/${this.state.workshop.id}`;
    let formData = new FormData();

    formData.append(field, file);

    new HttpClient().multipart(url, formData, "PUT").then(response => {
      const workshop = response.body.data.workshop;
      this.setState({ workshop: workshop });
    });
  };

  loadCsv = e => {
    const file = e.currentTarget.files[0];
    const url = `/api/v1/attendees_list`;
    let formData = new FormData();

    formData.append("csv", file);
    formData.append("workshop_id", this.state.workshop.id);

    new HttpClient().multipart(url, formData, "POST").then(response => {
      const attendees = response.body.attendees;
      this.setState({
        ...this.state,
        workshop: {
          ...this.state.workshop,
          attendees: attendees
        }
      });
      this.props.alert.success("CSV Loaded!");
    });
  };

  render() {
    const { workshop } = this.state;

    return (
      <main className="main-content purchased">
        <div className="provider-bio container-fluid">
          <div className="row my-regular-workshop-single">
            <MyRegularWS_List
              workshop={workshop}
              onDelete={this.onDelete}
              onEdit={this.onEdit}
              selectedCheckbox={this.selectedCheckbox}
              sendSertificate={this.sendSertificate}
              selected={this.state.selected}
              selectAll={this.selectAll}
              showEmailTemplate={this.showEmailTemplate}
              showCertTemplate={this.showCertTemplate}
            />
            <MyRegularWS_Panel
              workshop={workshop}
              showModal={this.showModal}
              loadAttachment={this.loadAttachment}
              loadCsv={this.loadCsv}
            />
          </div>
        </div>
      </main>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/myRegularWorkshop/MyRegularWS_Attendees.jsx